import { toRaw } from 'vue';

import axios from '@/plugins/axios.js';

function base64PayloadToBlob(data, mimeType) {
    if (!data || typeof data !== 'string') {
        return null;
    }

    const base64 = data.includes(',') ? data.split(',')[1] : data;

    try {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);

        for (let index = 0; index < binary.length; index += 1) {
            bytes[index] = binary.charCodeAt(index);
        }

        return new Blob([bytes], { type: mimeType || 'application/octet-stream' });
    } catch {
        return null;
    }
}

/**
 * Resolve a File/Blob from a media item (Vue reactive proxies break instanceof File).
 */
export function getAttachmentFile(item) {
    const candidate = toRaw(item?.file) ?? item?.file;

    if (candidate instanceof Blob) {
        return candidate;
    }

    return base64PayloadToBlob(item?.data, item?.type);
}

export function announcementMediaHasUploadableFiles(media = []) {
    return media.some(item => getAttachmentFile(item) !== null);
}

export function buildCourseAnnouncementFormData(payload, media = []) {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
        if (key === 'media' || value === null || value === undefined) {
            return;
        }

        if (typeof value === 'boolean') {
            formData.append(key, value ? '1' : '0');
            return;
        }

        formData.append(key, value);
    });

    media.forEach((item, index) => {
        formData.append(`media[${index}][name]`, item.name ?? '');

        const file = getAttachmentFile(item);

        if (file) {
            formData.append(`media[${index}][file]`, file, item.name ?? 'upload');
        }
    });

    return formData;
}

export function postCourseAnnouncement(courseId, payload, media = []) {
    const url = `/api/courses/${courseId}/announcements`;

    if (announcementMediaHasUploadableFiles(media)) {
        return axios.post(url, buildCourseAnnouncementFormData(payload, media), {
            errorHandle: false,
        });
    }

    const { media: _media, ...jsonPayload } = payload;

    return axios.post(url, jsonPayload, { errorHandle: false });
}
